import React from "react";

import { Checkbox, FormControlLabel } from "@material-ui/core";

export const GCheckbox = ({ value, checked, onChange = () => {}, color="primary", labelPlacement = "start", label = false, ...props }) => {
    return (
        <FormControlLabel
            disabled={props.disabled}
            control={<Checkbox checked={checked} value={value} onChange={(e) => onChange(e, value)} disabled={props.disabled}  color={color} {...props} />}
            {...(label ? { label, labelPlacement } : {})}
            {...props}
        />
    );
};